module.exports = __webpack_public_path__ + "img/date_retard_72.9d220114.jpg";